import { Button } from '#app/components/ui/button'
import { Icon } from '#app/components/ui/icon'

interface ARTInfoScreenProps {
	onNext: () => void
	onBack: () => void
}

export function ARTInfoScreen({ onNext, onBack }: ARTInfoScreenProps) {
	return (
		<div className="flex h-full w-full flex-col gap-4 md:gap-6">
			<div className="flex w-full shrink-0 items-center justify-start gap-3">
				<div className="flex h-7 w-7 items-center justify-center gap-2.5 rounded-lg bg-green-50 p-2 md:h-auto md:w-auto md:rounded-xl">
					<Icon name="file-text" className="size-4 text-green-800 md:size-5" />
				</div>
				<div className="flex flex-1 flex-col items-start justify-start gap-1">
					<p className="font-parkinsans w-full text-sm leading-5 font-medium text-green-800 md:text-lg md:leading-8">
						Seguro ART
					</p>
				</div>
			</div>

			<div className="flex min-h-0 w-full flex-1 items-start justify-start overflow-hidden">
				<div
					className="font-parkinsans h-full w-full justify-start overflow-y-auto text-sm leading-5 text-neutral-900 [&::-webkit-scrollbar]:w-1.5 [&::-webkit-scrollbar-thumb]:rounded-full [&::-webkit-scrollbar-thumb]:bg-neutral-600 [&::-webkit-scrollbar-track]:bg-transparent"
					style={{
						scrollbarWidth: 'thin',
						scrollbarColor: '#525252 transparent',
					}}
				>
					<span className="font-medium">La cobertura incluye:</span>
					<br />
					<br />
					<span className="font-medium">Cobertura médica:</span>
					<span className="font-normal">
						{' '}
						cubre los gastos médicos necesarios para tratar las lesiones o
						enfermedades causadas por accidentes laborales. Esto puede incluir
						atención médica, hospitalización, cirugía, medicamentos, terapia
						física y rehabilitación.
					</span>
					<br />
					<br />
					<span className="font-medium">Indemnización por incapacidad: </span>
					<span className="font-normal">
						en caso de que un empleado sufra una incapacidad temporal o
						permanente debido a un accidente laboral, el seguro de ART puede
						proporcionar indemnizaciones para compensar la pérdida de ingresos o
						la disminución de la capacidad de trabajo.
					</span>
					<br />
					<br />
					<span className="font-medium">
						Prestaciones por muerte o invalidez:
					</span>
					<span className="font-normal">
						{' '}
						en situaciones trágicas en las que un empleado fallece o sufre una
						invalidez total y permanente debido a un accidente laboral, el
						seguro de ART puede brindar prestaciones a los beneficiarios del
						empleado, como una indemnización por muerte o una pensión por
						invalidez.
					</span>
					<br />
					<br />
					<span className="font-medium">
						Rehabilitación y readaptación laboral:{' '}
					</span>
					<span className="font-normal">
						cobertura de gastos de programas de rehabilitación y readaptación
						laboral para ayudar a los empleados a recuperarse de sus lesiones y
						reintegrarse al entorno laboral de manera segura.
					</span>
					<br />
					<br />
					<span className="font-medium">Asistencia legal y defensa:</span>
					<span className="font-normal">
						{' '}
						en el caso de que se produzcan disputas legales relacionadas con
						accidentes de trabajo, el seguro de ART puede proporcionar
						asistencia legal y defensa al empleador, protegiéndolo de demandas y
						costos legales adicionales.
					</span>
				</div>
			</div>

			<div className="flex w-full shrink-0 flex-col items-center justify-start gap-2 bg-white pt-4 md:flex-row md:justify-between md:bg-transparent md:pt-8">
				<Button
					variant="primary"
					appearance="text"
					size="l"
					onClick={onBack}
					className="order-2 w-full gap-2 rounded-xl px-4 py-3 text-sm leading-4 md:order-1 md:w-auto md:px-6 md:py-4 md:text-base md:leading-5"
				>
					<Icon name="arrow-left" className="size-4" />
					Volver
				</Button>
				<Button
					variant="secondary"
					appearance="solid"
					size="l"
					onClick={onNext}
					className="order-1 w-full md:order-2 md:w-auto"
				>
					Cotizar ahora
				</Button>
			</div>
		</div>
	)
}
